<nav class="navbar navbar-expand-lg navbar-light header-navbar {{transparentBGClass}}" [ngClass]="{'navbar-brand-center': menuPosition === 'Top', 'navbar-static': menuPosition === 'Side' &&
  config?.layout.navbar.type === 'Static' , 'navbar-sticky': menuPosition === 'Side' &&
  config?.layout.navbar.type === 'Fixed', 'fixed-top': isSmallScreen && menuPosition === 'Top'}">
  <div *ngIf="!isRegistrationRoute" class="container-fluid navbar-wrapper">
    <div class="navbar-container">
      <div class="collapse navbar-collapse d-block" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="dropdown nav-item" placement="bottom-left" display="static" ngbDropdown>
            <app-registration-tracker-navbar></app-registration-tracker-navbar>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="container-fluid navbar-wrapper">
    <div class="navbar-header d-flex">
      <div class="navbar-toggle menu-toggle d-xl-none d-block float-left align-items-center justify-content-center"
        data-toggle="collapse" (click)="toggleSidebar()">
        <i class="ft-menu font-medium-3"></i>
      </div>
    </div>
    <div class="navbar-container">
      <div class="collapse navbar-collapse d-block" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="dropdown nav-item" placement="bottom-left" display="static" ngbDropdown>
            <a class="nav-link dropdown-toggle dropdown-notification p-0 mt-2" id="drp-notification" href="javascript:;"
              data-toggle="dropdown" ngbDropdownToggle><i class="ft-bell font-medium-3"></i><span
                class="notification badge badge-pill red-bg">{{ getUnreadNotificationsCount() }}</span></a>
            <ul ngbDropdownMenu
              class="notification-dropdown dropdown-menu dropdown-menu-media dropdown-menu-right m-0 overflow-hidden">

              <li class="dropdown-menu-header">
                <div class="dropdown-header d-flex justify-content-between m-0 px-3 py-2 white bg-primary">
                  <div class="d-flex">
                    <i class="ft-bell font-medium-3 d-flex align-items-center mr-2"></i><span class="noti-title">{{
                      getUnreadNotificationsCount() }} nueva notificación</span>
                  </div>
                  <span (click)="marcarComoLeidoTodo()" class="text-bold-400 cursor-pointer">Marcar todo leído</span>
                </div>
              </li>
              <ng-container *ngIf="getUnreadNotificationsCount() > 0; else noNotifications">
                <li class="scrollable-container" [perfectScrollbar]>
                  <a *ngFor="let communication of serverSideRowData" class="d-flex justify-content-between"
                    href="javascript:void(0)">
                    <ng-container
                      *ngIf="!communication.has_read && communication.destination !== 'whatsapp' && isDateValid(communication.date_end)">
                      <div class="media d-flex align-items-center">
                        <div class="media-body">
                          <small style="padding-inline: 5px; border-radius: 10px;" [ngClass]="{
                            'bg-light-success': communication.type == 'evento',
                            'bg-light-info': communication.type == 'info',
                            'bg-light-warning': communication.type == 'urgente'
                          }">
                            <span *ngIf="communication.type"> {{
                              communication.type == "evento" ? "EVENTO" :
                              (communication.type == "info" ? "INFORMACIÓN" :
                              (communication.type == "urgente" ? "URGENTE" :
                              (communication.type == "mp3" ? "Audio" : "Desconocido")))
                              }}</span>
                          </small>

                          <h6 class="noti-text font-small-3 m-0">{{ communication.title }}</h6>
                        </div>
                        <div>
                          <button class="btn-primary btn-sm" style="font-size: 10px;"
                            (click)="marcarComoLeido(communication.user_id)">VER</button>
                        </div>
                      </div>
                    </ng-container>

                  </a>
                </li>
              </ng-container>
              <ng-template #noNotifications>
                <li class="text-center m-2">No hay notificaciones</li>
              </ng-template>
              <li class="dropdown-menu-footer">
                <div (click)="marcarComoLeidoTodo()"
                  class="noti-footer text-center cursor-pointer primary border-top text-bold-400 py-1">
                  Marcar todo leído
                </div>
              </li>
            </ul>
          </li>
          <li class="dropdown nav-item mr-1" placement="bottom-left" display="static" ngbDropdown>
            <a class="nav-link dropdown-toggle user-dropdown d-flex align-items-end" id="dropdownBasic2"
              href="javascript:;" data-toggle="dropdown" ngbDropdownToggle>
              <div class="user d-md-flex d-none mr-2">
                <span class="text-right">{{ userName }}</span>
                <div class="navbar-rol-container d-flex flex-row-reverse mt-1">
                  <span class="d-flex align-items-center text-right text-muted font-small-3">Conectado</span>
                  <div *ngIf="!userRole.isDefaultUser" class="d-flex align-items-center badge badge-pill"
                    [ngClass]="userRole.class">
                    {{ userRole.role }}
                  </div>
                </div>
              </div>
              <div class="avatar mr-1 ml-0">
                <img *ngIf="profilePicture; else defaultImg" [src]="profilePicture" alt="profile-img"
                  class="avatar-content">
              </div>
              <ng-template #defaultImg>
                <div class="avatar-content">
                  {{ initialsName | uppercase }}
                </div>
              </ng-template>
            </a>

            <div class="dropdown-menu text-left dropdown-menu-right m-0 pb-0" aria-labelledby="dropdownBasic2"
              ngbDropdownMenu>
              <!-- <a class="dropdown-item" href="javascript:;">
                <div class="d-flex align-items-center">
                  <i class="ft-message-square mr-2"></i><span>Chat</span>
                </div>
              </a> -->
              <a class="dropdown-item" routerLink="{{'pages/account-settings'}}">
                <div class="d-flex align-items-center">
                  <i class="ft-edit mr-2"></i><span>Editar Perfil</span>
                </div>
              </a>
              <!-- <a class="dropdown-item" href="javascript:;">
                <div class="d-flex align-items-center">
                  <i class="ft-mail mr-2"></i><span>My Inbox</span>
                </div>
              </a>  -->
              <div class="dropdown-divider"></div>
              <!-- <a class="dropdown-item" routerLink="/pages/login"> -->
              <a class="dropdown-item" (click)="logOut()">
                <div class="d-flex align-items-center">
                  <i class="ft-power mr-2"></i><span>Cerrar sesión</span>
                </div>
              </a>
            </div>
          </li>
          <!-- <li class="nav-item d-none d-lg-block mr-2 mt-1">
            <a class="nav-link notification-sidebar-toggle" (click)="toggleNotificationSidebar();"><i
                class="ft-align-right font-medium-3"></i></a>
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</nav>